import * as React from "react";

import { Input, NumericInput } from "Components/Form/Input";
import {
  getCollectionOfDittoComponents,
  getComponentTextByFieldId,
  useTexts,
} from "Components/TextContext";

import { PaddedSurface as Surface } from "App/global-style";
import { InputMode } from "Components/Form/Input/inputTypes";
import { VALUE_TYPE } from "Components/NumberValue";
import { TextComponentNameLevel1 } from "Components/TextContext/textConstants";
import { ProductCategory } from "Features/CheckPrice/Products/RiskProducts/Valuables/valuablesConstants";
import { ProductIntroFormValues } from "Features/CheckPrice/Products/RiskProducts/Valuables/valuablesInterface";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";

interface Props {
  formProps: FormikProps<ProductIntroFormValues>;
}

export const ValueAndDescription = (props: Props): React.ReactElement => {
  const { formProps } = props;
  const { getText } = useTexts();

  const { hint } = getCollectionOfDittoComponents(
    TextComponentNameLevel1.VALUABLES,
  );
  const product = formProps.values.product.toLowerCase();
  const description = getComponentTextByFieldId(hint, `description_${product}`);

  return (
    <Surface className="data-hj-suppress">
      {formProps.values.product !== ProductCategory.GOLF_EQUIPEMENT && (
        <Input
          as="textarea"
          id="description"
          name="description"
          label={getText("valuablesform.label.description")}
          hint={description}
          rows={3}
          error={getError("description", formProps)}
          fluid
          inputMode={InputMode.TEXT}
        />
      )}

      <NumericInput
        id="coverage_amount"
        name="coverage_amount"
        label={getText("valuablesform.label.coverage_amount")}
        hint={getText("valuablesform.hint.coverage_amount")}
        inputMode={InputMode.NUMERIC}
        suffix={VALUE_TYPE.NOK}
        error={getError("coverage_amount", formProps)}
        large
      />
    </Surface>
  );
};
